import './App.css'; 
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Articles from './pages/Articles';
import Article from './pages/Article';
import DynamicTitle from './components/DynamicTitle';
import Error from './pages/Error';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import RoadMap from './pages/RoadMap';
import TotemInfo from './pages/TotemInfo';
import TotemTouch from './pages/TotemTouch';
import Influencer from './pages/Influencer';
import PartnerFinanziario from './pages/PartnerFinanziario';
import PartnerFinanziarioOperativo from './pages/PartnerFinanziarioOperativo';
import AdsCreator from './pages/AdsCreator';
import VirtualInfluencer from './pages/VirtualInfluencer';
import ContentCreator from './pages/ContentCreator';
import ThanksPage from './pages/ThanksPage';
import LandingPage from './pages/LandingPage';
import PartnerStilista from "./pages/Stilista";
import PartnerPersonalShopper from "./pages/PersonalShopper";
import FashionAndDesign from "./pages/Fashion-Design";
import Tech from "./pages/Tech";
import Events from "./pages/Events";
import Communities from "./pages/Communities";
import Campaign from "./pages/Campaign";

function App() {
    return (
        <>
            <DynamicTitle />
            <div className="body_wrapper">
                <Header />
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path='/roadmap' element={<RoadMap/>} />
                    <Route path='/landingpage' element={<LandingPage/>} />
                    <Route path='/totemtouch' element={<TotemTouch/>} />
                    <Route path='/influencer' element={<Influencer/>} />
                    <Route path='/adscreator' element={<AdsCreator/>} />
                    <Route path='/thankspage' element={<ThanksPage/>} />
                    <Route path='/virtualinfluencer' element={<VirtualInfluencer/>} />
                    <Route path='/contentcreator' element={<ContentCreator/>} />
                    <Route path='/fashion-design' element={<FashionAndDesign/>}/>
                    <Route path='/tech' element={<Tech/>}/>
                    <Route path='/events' element={<Events/>}/>
                    <Route path='/communities' element={<Communities/>} />
                    <Route path='/campaign' element={<Campaign/>} />

                    <Route path='/partnerfinanziario' element={<PartnerFinanziario/>} />
                    <Route path='/partnerfinanziariooperativo' element={<PartnerFinanziarioOperativo/>} />
                    <Route path='/toteminfo' element={<TotemInfo/>} />
                    <Route path="/articles" element={<Articles />} />
                    <Route path="/stilista" element={<PartnerStilista/>}/>
                    <Route path="/personalshopper" element={<PartnerPersonalShopper/>}/>
                    <Route path="/article/:slug" element={<Article />} />
                    <Route path="*" element={<Error />} />
                    {/* Rotta di fallback per gestire le pagine non trovate */}
                </Routes>
                <Footer />
            </div>
            {/*<a id="back-to-top" title="Back to Top"></a> */}
         
        </>
    );
}

export default App;
